import { AppService } from '@aperza/util';
import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { notifyMessage } from '@aperza/ac-ui';
import Cookies from 'js-cookie';
const serverHost = AppService.serverHost();
const cloudServerHost = AppService.cloudServerHost();
const wwwServerHost = AppService.wwwServerHost();
const aperzaCloudCookieWhiteList = ['_ctkn', '_scc', '_scf', 'SESSION'];
const createApolloClient = (name) => {
    const appName = name || 'aperza-app';
    const httpLink = createHttpLink({
        uri: `${serverHost}/graphql`,
        credentials: 'include',
    });
    const authLink = setContext(async (_, { headers }) => {
        const cookies = {};
        cookies.cloudDomain = serverHost.slice(serverHost.indexOf('.'), serverHost.lastIndexOf(':') > serverHost.indexOf('.')
            ? serverHost.lastIndexOf(':')
            : serverHost.length);
        if (Cookies.get()) {
            Object.keys(Cookies.get()).forEach((key) => {
                if (aperzaCloudCookieWhiteList.includes(key)) {
                    cookies[key] = Cookies.get(key);
                }
            });
        }
        return {
            headers: {
                ...headers,
                'Aperza-App': appName,
                'Aperza-Cloud-Cookie': JSON.stringify(cookies),
            },
        };
    });
    const errorLink = onError(({ graphQLErrors, networkError, response }) => {
        if (graphQLErrors)
            graphQLErrors.forEach(({ message, locations, path, name, extensions, nodes }) => {
                // notifyMessage(`GraphQL error ${message}`, 'ERROR');
            });
        if (networkError) {
            // @ts-ignore
            const { statusCode } = networkError;
            const errorMessage = 'タイムアウトしました。リロードしてください。';
            if (statusCode === 401) {
                // should sign out
            }
            else if (statusCode === 504) {
                // timed out
            }
            notifyMessage(errorMessage, 'ERROR', {
                autoClose: false,
            });
            if (!response) {
                response = {};
            }
            response.errors = null;
        }
    });
    const apolloClient = new ApolloClient({
        name: appName,
        connectToDevTools: true,
        cache: new InMemoryCache(),
        link: from([errorLink, authLink.concat(httpLink)]),
    });
    return apolloClient;
};
const createApolloClientForm = (appName = 'aperza-app') => {
    // console.log(
    //   'video end point for apollo client endpoint => ' + `${cloudServerHost}/contents/video/graphql`
    // );
    const httpLink = createHttpLink({
        uri: `${cloudServerHost}/contents/form/graphql`,
        credentials: 'include',
    });
    const authLink = setContext(async (_, { headers }) => {
        // const cookies: Record<string, any> = {};
        // cookies.cloudDomain = serverHost.slice(
        //   serverHost.indexOf('.'),
        //   serverHost.lastIndexOf(':') > serverHost.indexOf('.')
        //     ? serverHost.lastIndexOf(':')
        //     : serverHost.length
        // );
        // if (Cookies.get()) {
        //   Object.keys(Cookies.get()).forEach((key) => {
        //     if (aperzaCloudCookieWhiteList.includes(key)) {
        //       cookies[key] = Cookies.get(key);
        //     }
        //   });
        // }
        return {
            headers: {
                ...headers,
                // 'Aperza-App': appName,
                // 'Aperza-Cloud-Cookie': JSON.stringify(cookies),
            },
        };
    });
    const options = {
    // typePolicies: {
    //   CustomFormPage: { keyFields: ['customFormId'] },  // try and use default id
    // },
    };
    const apolloClient = new ApolloClient({
        name: appName,
        connectToDevTools: true,
        cache: new InMemoryCache(options),
        link: authLink.concat(httpLink),
    });
    return apolloClient;
};
const createApolloClientVideo = (name) => {
    const appName = name ? name : 'aperza-app';
    // console.log(
    //   'video end point for apollo client endpoint => ' + `${cloudServerHost}/contents/video/graphql`
    // );
    const httpLink = createHttpLink({
        uri: `${cloudServerHost}/contents/video/graphql`,
        credentials: 'include',
    });
    const authLink = setContext(async (_, { headers }) => {
        // const cookies: Record<string, any> = {};
        // cookies.cloudDomain = serverHost.slice(
        //   serverHost.indexOf('.'),
        //   serverHost.lastIndexOf(':') > serverHost.indexOf('.')
        //     ? serverHost.lastIndexOf(':')
        //     : serverHost.length
        // );
        // if (Cookies.get()) {
        //   Object.keys(Cookies.get()).forEach((key) => {
        //     if (aperzaCloudCookieWhiteList.includes(key)) {
        //       cookies[key] = Cookies.get(key);
        //     }
        //   });
        // }
        return {
            headers: {
                ...headers,
                // 'Aperza-App': appName,
                // 'Aperza-Cloud-Cookie': JSON.stringify(cookies),
            },
        };
    });
    const options = {
        typePolicies: {
            VideoPage: { keyFields: ['videoPageId'] },
        },
    };
    const apolloClient = new ApolloClient({
        name: appName,
        connectToDevTools: true,
        cache: new InMemoryCache(options),
        link: authLink.concat(httpLink),
    });
    return apolloClient;
};
const createApolloClientPage = (name) => {
    const appName = name ? name : 'aperza-app';
    const httpLink = createHttpLink({
        uri: `${wwwServerHost}/page/graphql`,
        credentials: 'include',
    });
    const authLink = setContext(async (_, { headers }) => {
        return {
            headers: {
                ...headers,
            },
        };
    });
    const options = {
        typePolicies: {
            VideoPage: { keyFields: ['videoPageId'] },
        },
    };
    const apolloClient = new ApolloClient({
        name: appName,
        connectToDevTools: true,
        cache: new InMemoryCache(options),
        link: authLink.concat(httpLink),
    });
    return apolloClient;
};
export { createApolloClient, createApolloClientVideo, createApolloClientPage, createApolloClientForm, };
